var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { SUPPORTED_PREDICATES as TYPES } from '../constants/types';
import { DURATION_UNIT_VALUES } from '../constants/dropdowns';
import { LOCATION_PLUGIN_UIDS, LOCATION_CATEGORY_DISPLAY_NAMES, LOCATION_ATTRIBUTE_NAMES, LOCATION_ATTRIBUTE_DISPLAY_NAMES, LOCATION_ATTRIBUTE_UIDS, LOCATION_CATEGORY_NAMES, } from '../constants/location';
import { retrieveOperatorValue } from '../utils/helpers';
export function flattenToArray(args, _a) {
    var data = __rest(_a, []);
    var depth = args === null || args === void 0 ? void 0 : args.maxDepth;
    if (depth === undefined && args.length === 0) {
        depth = 'root';
    }
    return args.concat([__assign({ depth: depth }, data)]);
}
var LOCATION_ATTRIBUTE_UID_LIST = Object.values(LOCATION_ATTRIBUTE_UIDS);
export var NODE_ID_NUMERIC_PATTERN = /\d+/;
export var NODE_ID_ALPHABET_PATTERN = /[a-zA-Z]+/;
export var NODE_ID_ALPHA_NUMERIC_PATTERN = /\d+[a-zA-Z]+/;
export var deserializeDuration = function (value) {
    var durationValue = {
        duration: value || '',
        unit: DURATION_UNIT_VALUES[0].name,
    };
    for (var count = DURATION_UNIT_VALUES.length - 1; count >= 0; count--) {
        if (Number(value) >= DURATION_UNIT_VALUES[count].seconds) {
            durationValue.duration = Math.round(Number(value) / Number(DURATION_UNIT_VALUES[count].seconds)).toString();
            durationValue.unit = DURATION_UNIT_VALUES[count].name;
            break;
        }
    }
    return durationValue;
};
export var checkIfNodeNegated = function (nodeId, logicString) {
    var _logicString = logicString.toLowerCase();
    var _nodeId = nodeId.toLowerCase();
    var nodeIdPosInLogicString = _logicString.indexOf(_nodeId);
    if (nodeIdPosInLogicString === -1 || nodeIdPosInLogicString === 0) {
        return false;
    }
    var nodeIdPrevCharInLogicString = _logicString.charAt(nodeIdPosInLogicString - 1);
    if (nodeIdPrevCharInLogicString === '~') {
        return true;
    }
    else {
        return false;
    }
};
export var getUIMap = function (payload, contextPlugins) {
    var e_1, _a;
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11;
    var _12 = payload !== null && payload !== void 0 ? payload : {}, predicates = _12.predicates, logic = _12.logic, constraints = _12.constraints, rest = __rest(_12, ["predicates", "logic", "constraints"]);
    var ruleBlocks = [];
    var ctxPluginMap = {};
    contextPlugins === null || contextPlugins === void 0 ? void 0 : contextPlugins.forEach(function (plugin) {
        ctxPluginMap[plugin.uid] = plugin;
    });
    var constraintMap = {};
    if (constraints) {
        var predicateConstraints = constraints.predicateConstraints;
        var parameterConstraints = constraints.predicateParameterConstraints;
        predicateConstraints === null || predicateConstraints === void 0 ? void 0 : predicateConstraints.forEach(function (c) {
            var id = c.identifier.predicate;
            if (!constraintMap[id])
                constraintMap[id] = {};
            constraintMap[id].predicateConstraint = __assign({}, c.constraint);
        });
        parameterConstraints === null || parameterConstraints === void 0 ? void 0 : parameterConstraints.forEach(function (c) {
            var id = c.identifier.predicate;
            if (!constraintMap[id])
                constraintMap[id] = {};
            var type = predicates[id].parameters[c.identifier.parameter].type === 'constant' ? 'valueConstraint' : 'contextConstraint';
            constraintMap[id][type] = __assign({}, c.constraint);
        });
    }
    for (var property in predicates) {
        var predicate = predicates[property];
        // We are now assuming the first param is the CTX and second param is VALUE
        // on a string representation of boolEq(CTX, VALUE) for example
        // Later we'll add a third parameter [VARIABLE] and handle this better because backend is very flexible
        var predicateFirstParam = (_b = predicate === null || predicate === void 0 ? void 0 : predicate.parameters) === null || _b === void 0 ? void 0 : _b[0];
        var predicateSecondParam = (_c = predicate === null || predicate === void 0 ? void 0 : predicate.parameters) === null || _c === void 0 ? void 0 : _c[1];
        var contextParameter = (predicateFirstParam === null || predicateFirstParam === void 0 ? void 0 : predicateFirstParam.type) === 'context' || (predicateFirstParam === null || predicateFirstParam === void 0 ? void 0 : predicateFirstParam.type) === 'dependency'
            ? predicateFirstParam
            : undefined;
        var historicalParameter = (predicateFirstParam === null || predicateFirstParam === void 0 ? void 0 : predicateFirstParam.type) === 'historical' ? predicateFirstParam : undefined;
        var constantParameter = (predicateSecondParam === null || predicateSecondParam === void 0 ? void 0 : predicateSecondParam.type) === 'constant' ? predicateSecondParam : undefined;
        // =====> NEW STUFF - KEEP FOR NOW
        var contextComparisonPlugin = (predicateSecondParam === null || predicateSecondParam === void 0 ? void 0 : predicateSecondParam.type) === 'context' ? predicateSecondParam : undefined;
        // =====> END OF NEW STUFF
        // =====> OLD STUFF - DELETE?
        // Does the "same" thing but it is unreliable
        // const contextParameter = predicate?.parameters?.find(
        //   (el: { type: string }) => el.type === 'context' || el.type === 'dependency',
        // );
        // const historicalParameter = predicate?.parameters?.find((el: { type: string }) => el.type === 'historical');
        // const constantParameter = predicate?.parameters?.find((el: { type: string }) => el.type === 'constant');
        // =====> END OF OLD STUFF
        var delimitedAttributeName = ((_d = historicalParameter === null || historicalParameter === void 0 ? void 0 : historicalParameter.attribute) === null || _d === void 0 ? void 0 : _d.split('.')) || ((_e = contextParameter === null || contextParameter === void 0 ? void 0 : contextParameter.attribute) === null || _e === void 0 ? void 0 : _e.split('.'));
        var sanitizedAttributeName = (delimitedAttributeName === null || delimitedAttributeName === void 0 ? void 0 : delimitedAttributeName[0]) === 'query'
            ? delimitedAttributeName === null || delimitedAttributeName === void 0 ? void 0 : delimitedAttributeName[1]
            : historicalParameter
                ? historicalParameter === null || historicalParameter === void 0 ? void 0 : historicalParameter.attribute
                : contextParameter === null || contextParameter === void 0 ? void 0 : contextParameter.attribute;
        var categoryValue = historicalParameter
            ? (_g = (_f = historicalParameter === null || historicalParameter === void 0 ? void 0 : historicalParameter.plugin) === null || _f === void 0 ? void 0 : _f.split('.')) === null || _g === void 0 ? void 0 : _g[2]
            : (_j = (_h = contextParameter === null || contextParameter === void 0 ? void 0 : contextParameter.plugin) === null || _h === void 0 ? void 0 : _h.split('.')) === null || _j === void 0 ? void 0 : _j[2];
        var ctxVariableValue = historicalParameter
            ? (historicalParameter === null || historicalParameter === void 0 ? void 0 : historicalParameter.plugin) + '.' + (historicalParameter === null || historicalParameter === void 0 ? void 0 : historicalParameter.attribute)
            : (contextParameter === null || contextParameter === void 0 ? void 0 : contextParameter.plugin) + '.' + (contextParameter === null || contextParameter === void 0 ? void 0 : contextParameter.attribute);
        var ctxPluginUid = historicalParameter ? historicalParameter === null || historicalParameter === void 0 ? void 0 : historicalParameter.plugin : contextParameter === null || contextParameter === void 0 ? void 0 : contextParameter.plugin;
        var pluginAttribute = (_k = ctxPluginMap[ctxPluginUid]) === null || _k === void 0 ? void 0 : _k.values[sanitizedAttributeName];
        // highly unfortunate, but a lot of our values have bogus iconUrl values
        var iconUrl = /*pluginAttribute?.iconUrl ??*/ (_m = (_l = ctxPluginMap[ctxPluginUid]) === null || _l === void 0 ? void 0 : _l.iconUrl) !== null && _m !== void 0 ? _m : '';
        var contextParameterType = pluginAttribute
            ? pluginAttribute.isTimeContext
                ? TYPES.DATE
                : pluginAttribute.valueType
            : historicalParameter
                ? historicalParameter === null || historicalParameter === void 0 ? void 0 : historicalParameter.dataType
                : contextParameter === null || contextParameter === void 0 ? void 0 : contextParameter.dataType;
        var constantParameterType = constantParameter === null || constantParameter === void 0 ? void 0 : constantParameter.dataType;
        var parameterValues = [];
        if (historicalParameter) {
            for (var count = 1; count <= 5; count++) {
                var paramKey = "param".concat(count);
                historicalParameter[paramKey] && parameterValues.push(historicalParameter[paramKey]);
            }
        }
        else {
            parameterValues = (delimitedAttributeName === null || delimitedAttributeName === void 0 ? void 0 : delimitedAttributeName[0]) === 'query' ? delimitedAttributeName.slice(2) : undefined;
        }
        var categoryDisplayName = contextParameter === null || contextParameter === void 0 ? void 0 : contextParameter.categoryDisplayName;
        var attributeDisplayName = contextParameter === null || contextParameter === void 0 ? void 0 : contextParameter.attributeDisplayName;
        var ctxAttributeUid = contextParameter === null || contextParameter === void 0 ? void 0 : contextParameter.ctxAttributeUid;
        var placeholderValue = {
            name: predicate.hasPlaceHolder || false,
            contextOrHistorical: (contextParameter === null || contextParameter === void 0 ? void 0 : contextParameter.hasPlaceHolder) ||
                (historicalParameter === null || historicalParameter === void 0 ? void 0 : historicalParameter.hasPlaceHolder) ||
                ((_p = (_o = predicate.parameters) === null || _o === void 0 ? void 0 : _o[0]) === null || _p === void 0 ? void 0 : _p.hasPlaceHolder) ||
                false,
            constant: (constantParameter === null || constantParameter === void 0 ? void 0 : constantParameter.hasPlaceHolder) || ((_r = (_q = predicate.parameters) === null || _q === void 0 ? void 0 : _q[1]) === null || _r === void 0 ? void 0 : _r.hasPlaceHolder) || false,
        };
        var operatorValue = historicalParameter ? (_t = (_s = historicalParameter === null || historicalParameter === void 0 ? void 0 : historicalParameter.where) === null || _s === void 0 ? void 0 : _s[0]) === null || _t === void 0 ? void 0 : _t.operator : predicate.name;
        var typeValue = historicalParameter ? historicalParameter === null || historicalParameter === void 0 ? void 0 : historicalParameter.type : contextParameter === null || contextParameter === void 0 ? void 0 : contextParameter.type;
        if (!typeValue && ((_v = (_u = predicate.parameters) === null || _u === void 0 ? void 0 : _u[0]) === null || _v === void 0 ? void 0 : _v.hasPlaceHolder) && ((_x = (_w = predicate.parameters) === null || _w === void 0 ? void 0 : _w[0]) === null || _x === void 0 ? void 0 : _x.type) === '{{P}}') {
            typeValue = (_z = (_y = predicate.parameters) === null || _y === void 0 ? void 0 : _y[0]) === null || _z === void 0 ? void 0 : _z.type;
        }
        var constantParamValue = constantParameter
            ? constantParameter === null || constantParameter === void 0 ? void 0 : constantParameter.value
            : contextParameterType === 'bool'
                ? 'true'
                : '';
        var ruleBlockData = __assign(__assign(__assign({ nodeId: property, iconUrl: iconUrl, category: categoryValue, attributeName: sanitizedAttributeName, contextComparisonPlugin: contextComparisonPlugin, contextParameterType: contextParameterType, constantParameterType: constantParameterType, ctxVariable: ctxVariableValue, operator: operatorValue === '{{P}}' && contextParameterType ? retrieveOperatorValue(contextParameterType) : operatorValue, value: historicalParameter ? (_2 = (_1 = (_0 = historicalParameter === null || historicalParameter === void 0 ? void 0 : historicalParameter.where) === null || _0 === void 0 ? void 0 : _0[0]) === null || _1 === void 0 ? void 0 : _1.value) === null || _2 === void 0 ? void 0 : _2.toString() : constantParamValue, parameterValues: parameterValues, isExpanded: false, rawPredicate: predicate, useRaw: !constantParameter, type: typeValue, categoryDisplayName: categoryDisplayName, attributeDisplayName: attributeDisplayName, hasPlaceHolder: placeholderValue }, constraintMap[property]), ((contextParameter === null || contextParameter === void 0 ? void 0 : contextParameter.key) ? { key: contextParameter === null || contextParameter === void 0 ? void 0 : contextParameter.key } : {})), ((contextParameter === null || contextParameter === void 0 ? void 0 : contextParameter.dependencyType) ? { dependencyType: contextParameter === null || contextParameter === void 0 ? void 0 : contextParameter.dependencyType } : {}));
        var isCtxAttributeUidLocationType = LOCATION_ATTRIBUTE_UID_LIST.includes(ctxAttributeUid);
        // Location predicate
        if (isCtxAttributeUidLocationType && NODE_ID_ALPHA_NUMERIC_PATTERN.test(property)) {
            var groupNodeId = (_3 = property.match(NODE_ID_NUMERIC_PATTERN)) === null || _3 === void 0 ? void 0 : _3[0];
            var nodeId = ruleBlockData.nodeId, category = ruleBlockData.category, attributeName = ruleBlockData.attributeName, contextParameterType_1 = ruleBlockData.contextParameterType, constantParameterType_1 = ruleBlockData.constantParameterType, ctxVariable = ruleBlockData.ctxVariable, operator = ruleBlockData.operator, value = ruleBlockData.value, parameterValues_1 = ruleBlockData.parameterValues, isExpanded = ruleBlockData.isExpanded, type = ruleBlockData.type, valueConstraint = ruleBlockData.valueConstraint, predicateConstraint = ruleBlockData.predicateConstraint, contextConstraint = ruleBlockData.contextConstraint;
            var isRulesGroupNodeFound = false;
            try {
                for (var ruleBlocks_1 = (e_1 = void 0, __values(ruleBlocks)), ruleBlocks_1_1 = ruleBlocks_1.next(); !ruleBlocks_1_1.done; ruleBlocks_1_1 = ruleBlocks_1.next()) {
                    var ruleBlock = ruleBlocks_1_1.value;
                    if (ruleBlock.nodeId === groupNodeId) {
                        ruleBlock.rules.push({
                            nodeId: nodeId,
                            ctxVariable: ctxVariable,
                            parameterValues: parameterValues_1,
                            value: value,
                            attributeName: attributeName,
                            valueConstraint: valueConstraint,
                            predicateConstraint: predicateConstraint,
                            contextConstraint: contextConstraint,
                        });
                        isRulesGroupNodeFound = true;
                        break;
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (ruleBlocks_1_1 && !ruleBlocks_1_1.done && (_a = ruleBlocks_1.return)) _a.call(ruleBlocks_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            if (!isRulesGroupNodeFound) {
                ruleBlocks.push({
                    nodeId: groupNodeId,
                    iconUrl: iconUrl,
                    category: category,
                    attributeName: attributeName,
                    contextParameterType: contextParameterType_1,
                    constantParameterType: constantParameterType_1,
                    operator: operator,
                    value: value,
                    isExpanded: isExpanded,
                    type: type,
                    ctxVariable: ctxVariable,
                    categoryDisplayName: categoryDisplayName,
                    attributeDisplayName: attributeDisplayName,
                    ctxAttributeUid: ctxAttributeUid,
                    rules: [
                        {
                            nodeId: nodeId,
                            ctxVariable: ctxVariable,
                            parameterValues: parameterValues_1,
                            value: value,
                            attributeName: attributeName,
                            valueConstraint: valueConstraint,
                            predicateConstraint: predicateConstraint,
                            contextConstraint: contextConstraint,
                        },
                    ],
                });
            }
        } // All other predicates
        else {
            // Historical predicate
            if (historicalParameter) {
                ruleBlockData.historicalValue = {
                    histValue: constantParameter === null || constantParameter === void 0 ? void 0 : constantParameter.value,
                    histOperator: predicate === null || predicate === void 0 ? void 0 : predicate.name,
                    duration: deserializeDuration((_5 = (_4 = historicalParameter === null || historicalParameter === void 0 ? void 0 : historicalParameter.timeRange) === null || _4 === void 0 ? void 0 : _4[0]) === null || _5 === void 0 ? void 0 : _5.duration).duration || '',
                    durationUnit: deserializeDuration((_7 = (_6 = historicalParameter === null || historicalParameter === void 0 ? void 0 : historicalParameter.timeRange) === null || _6 === void 0 ? void 0 : _6[0]) === null || _7 === void 0 ? void 0 : _7.duration).unit,
                    functionValue: historicalParameter === null || historicalParameter === void 0 ? void 0 : historicalParameter.function,
                    durationFrom: (_9 = (_8 = historicalParameter === null || historicalParameter === void 0 ? void 0 : historicalParameter.timeRange) === null || _8 === void 0 ? void 0 : _8[0]) === null || _9 === void 0 ? void 0 : _9.from,
                    durationTo: (_11 = (_10 = historicalParameter === null || historicalParameter === void 0 ? void 0 : historicalParameter.timeRange) === null || _10 === void 0 ? void 0 : _10[0]) === null || _11 === void 0 ? void 0 : _11.to,
                    expiry: historicalParameter === null || historicalParameter === void 0 ? void 0 : historicalParameter.expiry,
                    negate: checkIfNodeNegated(ruleBlockData.nodeId, logic),
                };
            }
            ruleBlocks.push(ruleBlockData);
        }
    }
    var sortedRuleBlocks = ruleBlocks.sort(function (prevBlock, nextBlock) {
        var _a, _b;
        var prevBlockId = +((_a = prevBlock.nodeId.match(NODE_ID_NUMERIC_PATTERN)) === null || _a === void 0 ? void 0 : _a[0]);
        var nextBlockId = +((_b = nextBlock.nodeId.match(NODE_ID_NUMERIC_PATTERN)) === null || _b === void 0 ? void 0 : _b[0]);
        if (prevBlockId < nextBlockId) {
            return -1;
        }
        else if (prevBlockId > nextBlockId) {
            return 1;
        }
        else {
            return 0;
        }
    });
    return {
        condition: logic !== null && logic !== void 0 ? logic : '',
        uiBlocks: sortedRuleBlocks,
        constraints: constraints,
        inheritedPayloadProperties: rest,
    };
};
var calculateTotalDuration = function (value, unit) {
    var _a;
    if (value && unit) {
        return Number(value) * Number((_a = DURATION_UNIT_VALUES === null || DURATION_UNIT_VALUES === void 0 ? void 0 : DURATION_UNIT_VALUES.find(function (option) { return option.name === unit; })) === null || _a === void 0 ? void 0 : _a.seconds);
    }
    return '';
};
// will add rule capabilities a bit later
export var genUIBlock = function (contextPlugin, attributeName, nodeId, hasPlaceHolder, block) {
    var _a, _b, _c, _d, _e, _f;
    var iconUrl = /*contextPlugin.values[attributeName]?.iconUrl ??*/ (_a = contextPlugin.iconUrl) !== null && _a !== void 0 ? _a : '';
    var attributeValue = contextPlugin.values[attributeName];
    var parameterValues = ((_b = attributeValue === null || attributeValue === void 0 ? void 0 : attributeValue.parameters) === null || _b === void 0 ? void 0 : _b.length) > 0
        ? attributeValue.parameters.map(function (item) {
            var _a, _b, _c;
            return (_c = (_b = (_a = item.valueTypeOptions) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.value) !== null && _c !== void 0 ? _c : '*';
        })
        : undefined;
    var ruleBlock = {
        nodeId: nodeId,
        iconUrl: iconUrl,
        category: contextPlugin.category,
        attributeName: attributeName,
        contextParameterType: attributeValue ? (attributeValue.isTimeContext ? TYPES.DATE : attributeValue.valueType) : '',
        constantParameterType: attributeValue === null || attributeValue === void 0 ? void 0 : attributeValue.valueType,
        ctxVariable: attributeValue === null || attributeValue === void 0 ? void 0 : attributeValue.uid,
        operator: '',
        value: '',
        parameterValues: parameterValues,
        isExpanded: true,
        hasPlaceHolder: hasPlaceHolder,
    };
    var categoryDisplayName;
    var attributeDisplayName;
    var isLocationPlugin = contextPlugin.uid === LOCATION_PLUGIN_UIDS.APPROXIMATE || contextPlugin.uid === LOCATION_PLUGIN_UIDS.PRECISE;
    if ((hasPlaceHolder === null || hasPlaceHolder === void 0 ? void 0 : hasPlaceHolder.name) || (hasPlaceHolder === null || hasPlaceHolder === void 0 ? void 0 : hasPlaceHolder.contextOrHistorical) || (hasPlaceHolder === null || hasPlaceHolder === void 0 ? void 0 : hasPlaceHolder.constant)) {
        var hasPlaceHolderObj = {
            name: false,
            contextOrHistorical: false,
            constant: false,
        };
        var operatorData = (block === null || block === void 0 ? void 0 : block.operator) || '';
        var valueData = !(block === null || block === void 0 ? void 0 : block.value) || (block === null || block === void 0 ? void 0 : block.value) === '{{P}}' ? '' : block.value;
        if (operatorData === '{{P}}') {
            operatorData = retrieveOperatorValue((_c = contextPlugin.values[attributeName]) === null || _c === void 0 ? void 0 : _c.valueType) || '';
            valueData = ((_d = contextPlugin.values[attributeName]) === null || _d === void 0 ? void 0 : _d.valueType) === 'bool' ? 'true' : '';
        }
        if (((_e = contextPlugin === null || contextPlugin === void 0 ? void 0 : contextPlugin.values[attributeName]) === null || _e === void 0 ? void 0 : _e.valueType) === (block === null || block === void 0 ? void 0 : block.contextParameterType) &&
            block.type === 'historical') {
            return __assign(__assign({}, ruleBlock), { operator: operatorData, value: valueData, type: block.type, historicalValue: block.historicalValue, hasPlaceHolder: hasPlaceHolderObj });
        }
        return __assign(__assign({}, ruleBlock), { value: valueData, hasPlaceHolder: hasPlaceHolderObj, operator: operatorData });
    }
    else if (isLocationPlugin) {
        if (contextPlugin.uid === LOCATION_PLUGIN_UIDS.PRECISE) {
            ruleBlock.category = LOCATION_CATEGORY_NAMES.AREA;
        }
        else if (contextPlugin.uid === LOCATION_PLUGIN_UIDS.APPROXIMATE) {
            ruleBlock.category = LOCATION_CATEGORY_NAMES.APPROXIMATE_AREA;
        }
        var ctxAttributeUid = (_f = contextPlugin.values[attributeName]) === null || _f === void 0 ? void 0 : _f.uid;
        var locationCategoryName = void 0;
        if (contextPlugin.uid === LOCATION_PLUGIN_UIDS.APPROXIMATE) {
            locationCategoryName = LOCATION_CATEGORY_DISPLAY_NAMES.APPROXIMATE;
        }
        if (contextPlugin.uid === LOCATION_PLUGIN_UIDS.PRECISE) {
            locationCategoryName = LOCATION_CATEGORY_DISPLAY_NAMES.PRECISE;
        }
        var locationAttributeName = void 0;
        if (attributeName === LOCATION_ATTRIBUTE_NAMES.APPROXIMATE || attributeName === LOCATION_ATTRIBUTE_NAMES.PRECISE) {
            locationAttributeName = LOCATION_ATTRIBUTE_DISPLAY_NAMES.ADDRESS;
            ruleBlock.contextParameterType = TYPES.BOOL;
            ruleBlock.constantParameterType = TYPES.BOOL;
        }
        if (attributeName === LOCATION_ATTRIBUTE_NAMES.LABELS) {
            locationAttributeName = LOCATION_ATTRIBUTE_DISPLAY_NAMES.LABEL;
            ruleBlock.contextParameterType = TYPES.STR;
            ruleBlock.constantParameterType = TYPES.STR;
        }
        if (locationCategoryName && locationAttributeName) {
            categoryDisplayName = locationCategoryName;
            attributeDisplayName = locationAttributeName;
        }
        return __assign(__assign({}, ruleBlock), { categoryDisplayName: categoryDisplayName, attributeDisplayName: attributeDisplayName, ctxAttributeUid: ctxAttributeUid, rules: [] });
    }
    else {
        return ruleBlock;
    }
};
var serializeParameterBlocks = function (block) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0;
    var retVal = [];
    var attribute = '';
    var plugin = '';
    // Derive attribute
    if (((_a = block.parameterValues) === null || _a === void 0 ? void 0 : _a.length) && block.type !== 'historical') {
        attribute = "query.".concat(block.attributeName);
        block.parameterValues.forEach(function (value) {
            attribute += ".".concat(value.toString());
        });
    }
    else {
        attribute = block.attributeName;
    }
    // Derive plugin
    if (((_b = block.ctxVariable) === null || _b === void 0 ? void 0 : _b.includes('{{P}}')) || block.type === '{{P}}') {
        if (((_c = block.parameterValues) === null || _c === void 0 ? void 0 : _c.length) && block.type !== 'historical') {
            plugin = block.ctxVariable.split('.query.' + block.attributeName)[0];
        }
        else {
            plugin = block.ctxVariable.replace(new RegExp('.' + attribute + '([^' + '.' + attribute + ']*)$'), '' + '$1');
        }
    }
    else if (typeof block.ctxVariable !== 'undefined') {
        plugin = "ctx.".concat((_e = (_d = block.ctxVariable) === null || _d === void 0 ? void 0 : _d.split('.')) === null || _e === void 0 ? void 0 : _e[1], ".").concat((_g = (_f = block.ctxVariable) === null || _f === void 0 ? void 0 : _f.split('.')) === null || _g === void 0 ? void 0 : _g[2]);
    }
    // Create Historical parameter
    if (block.type === 'historical') {
        var timeRange = [
            {
                duration: calculateTotalDuration((_h = block.historicalValue) === null || _h === void 0 ? void 0 : _h.duration, (_j = block.historicalValue) === null || _j === void 0 ? void 0 : _j.durationUnit),
                from: ((_k = block.historicalValue) === null || _k === void 0 ? void 0 : _k.durationFrom) ? (_l = block.historicalValue) === null || _l === void 0 ? void 0 : _l.durationFrom : 0,
                to: ((_m = block.historicalValue) === null || _m === void 0 ? void 0 : _m.durationTo) ? (_o = block.historicalValue) === null || _o === void 0 ? void 0 : _o.durationTo : -1,
            },
        ];
        var whereValue = '';
        if (block.value !== '') {
            switch (block.contextParameterType) {
                case 'float':
                case 'int':
                case 'dateTime':
                    whereValue = Number(block.value);
                    break;
                case 'bool':
                    whereValue = block.value === 'true';
                    break;
                case 'string':
                    whereValue = block.value;
                    break;
            }
        }
        // loop through 5 parameters as a hotfix
        var historicalParameters = {};
        for (var i = 0; i < 5; i++) {
            var historicalParameterKey = "param".concat(i + 1);
            var historicalParam = (_p = block.parameterValues) === null || _p === void 0 ? void 0 : _p[i];
            if (historicalParam)
                historicalParameters[historicalParameterKey] = historicalParam;
        }
        retVal.push(__assign(__assign({ type: 'historical', where: [
                {
                    operator: block.operator,
                    value: whereValue,
                },
            ] }, historicalParameters), { function: (_s = (_q = block.function) !== null && _q !== void 0 ? _q : (_r = block.historicalValue) === null || _r === void 0 ? void 0 : _r.functionValue) !== null && _s !== void 0 ? _s : 'count', expiry: timeRange[0].duration, plugin: plugin, attribute: attribute, timeRange: timeRange }));
    } // Create Context parameter
    else {
        retVal.push(__assign(__assign({ type: block.type ? block.type : 'context', plugin: plugin, attribute: attribute, categoryDisplayName: block.categoryDisplayName, attributeDisplayName: block.attributeDisplayName, ctxAttributeUid: block.ctxAttributeUid }, (block.key ? { key: block.key } : {})), (block.dependencyType ? { dependencyType: block.dependencyType } : {})));
    }
    // "values"
    if (!!block.contextComparisonPlugin) {
        //Create Context parameter value
        retVal.push({
            type: 'context',
            plugin: block.contextComparisonPlugin.plugin,
            dataType: block.contextParameterType,
            attribute: block.contextComparisonPlugin.attribute,
        });
    }
    else {
        // Create Constant parameter
        var constantParameterType = block.constantParameterType;
        retVal.push({
            type: 'constant',
            value: block.type === 'historical' ? (_t = block.historicalValue) === null || _t === void 0 ? void 0 : _t.histValue : block.value,
            dataType: 
            // this is fine for now, but historicals under the hood are float
            block.type === 'historical' || block.contextParameterType === TYPES.DATE ? TYPES.INT : constantParameterType,
            allowedValues: (_u = block.dropDownOptions) === null || _u === void 0 ? void 0 : _u.map(function (option) { return option.key; }),
        });
    }
    // Set `hasPlaceHolder` property in the predicate parameters
    if (((_v = block.hasPlaceHolder) === null || _v === void 0 ? void 0 : _v.contextOrHistorical) && block.ctxVariable.includes('{{P}}')) {
        retVal.find(function (option) { return option.type === 'context' || option.type === 'historical'; }).hasPlaceHolder =
            ((_w = block === null || block === void 0 ? void 0 : block.hasPlaceHolder) === null || _w === void 0 ? void 0 : _w.contextOrHistorical) || false;
    }
    if (((_x = block.hasPlaceHolder) === null || _x === void 0 ? void 0 : _x.contextOrHistorical) && block.type === '{{P}}') {
        retVal.find(function (option) { return option.type === '{{P}}'; }).hasPlaceHolder = ((_y = block === null || block === void 0 ? void 0 : block.hasPlaceHolder) === null || _y === void 0 ? void 0 : _y.contextOrHistorical) || false;
    }
    if (((_z = block.hasPlaceHolder) === null || _z === void 0 ? void 0 : _z.constant) && !block.value) {
        retVal.find(function (option) { return option.type === 'constant'; }).hasPlaceHolder = ((_0 = block === null || block === void 0 ? void 0 : block.hasPlaceHolder) === null || _0 === void 0 ? void 0 : _0.constant) || false;
    }
    return retVal;
};
var LOGICAL_OPERATORS = ['or', 'and'];
export var getLogicStringTokens = function (logicString, separateNegate) {
    if (separateNegate === void 0) { separateNegate = false; }
    var token = '';
    var logicStringTokens = [];
    for (var logicStringIdx = 0; logicStringIdx < logicString.length; logicStringIdx++) {
        var char = logicString[logicStringIdx];
        if (char === '(') {
            logicStringTokens.push(char);
        }
        else if (char === ')') {
            var trimmedToken = token.trim();
            trimmedToken && logicStringTokens.push(trimmedToken);
            logicStringTokens.push(char);
            token = '';
        }
        else if (char === ' ') {
            var trimmedToken = token.trim();
            trimmedToken && logicStringTokens.push(trimmedToken);
            token = '';
        }
        else if (char === '~' && separateNegate) {
            logicStringTokens.push(char);
        }
        else {
            token += char;
        }
    }
    if (token) {
        var trimmedToken = token.trim();
        trimmedToken && logicStringTokens.push(token);
    }
    return logicStringTokens;
};
export var assembleLogicString = function (tokens) {
    var logicString = '';
    for (var i = 0; i < tokens.length; i++) {
        var token = tokens[i];
        var lookAhead = tokens[i + 1];
        switch (token) {
            case '~':
            case '(':
                logicString += token;
                break;
            default:
                if (lookAhead && lookAhead === ')')
                    logicString += token;
                else
                    logicString += "".concat(token, " ");
        }
    }
    return logicString;
};
export var getLogicStringOperator = function (logicStringTokens) {
    // Considering the default operator as 'and'
    // if there is only one rule node
    if (logicStringTokens.length <= 1) {
        return 'and';
    }
    for (var i = 0; i < logicStringTokens.length; i++) {
        var logicStringToken = logicStringTokens[i];
        if ((NODE_ID_NUMERIC_PATTERN.test(logicStringToken) || NODE_ID_ALPHA_NUMERIC_PATTERN.test(logicStringToken)) &&
            i + 1 < logicStringTokens.length) {
            var nextLogicStringToken = logicStringTokens[i + 1].toLowerCase();
            // If there is no logic operator after a non-group node
            if (nextLogicStringToken === ')') {
                i++;
            }
            else {
                // If there is a logic operator after a non-group node
                return logicStringTokens[i + 1].toLowerCase();
            }
        }
        else if (logicStringToken === '(') {
            // Jump to closing paren when encountering a opening paren (group)
            var closingParenIdx = logicStringTokens.indexOf(')', i);
            var nextTokenIdx = closingParenIdx + 1;
            // If there is a logic operator after a closing paren (group)
            if (nextTokenIdx < logicStringTokens.length) {
                return logicStringTokens[nextTokenIdx].toLowerCase();
            }
        }
    }
    // Considering the default operator as 'and'
    // if there is only one rule group
    return 'and';
};
/**
 * Recursivley add to a key map.
 * Only works for two-deep blocks.
 * Use toRaw to indicate direction of map (raw -> display is false).
 * Bias indicates if there should be a numeric bias.
 * */
function addKeys(keyMap, uiBlocks, toRaw, bias) {
    if (toRaw === void 0) { toRaw = false; }
    // will fail if there are > 26 ui blocks and a bias
    uiBlocks.forEach(function (block, i) {
        var key = block.nodeId;
        var displayKey = bias ? bias + String.fromCharCode(97 + i) : (i + 1).toString();
        if (toRaw)
            keyMap[displayKey] = key;
        else
            keyMap[key] = displayKey;
        if (block.rules && block.rules.length > 0)
            addKeys(keyMap, block.rules, toRaw, displayKey);
    });
}
/**
 * Translates raw logic string into something visually congruent with display
 * indices.
 * */
export var translateLogicString = function (logicString, uiBlocks, toRaw) {
    if (toRaw === void 0) { toRaw = false; }
    // key -> display key map
    var keyMap = {};
    addKeys(keyMap, uiBlocks, toRaw);
    var tokens = getLogicStringTokens(logicString, true);
    var mappedTokens = tokens.map(function (token) {
        if (token in keyMap)
            return keyMap[token];
        else
            return token;
    });
    return assembleLogicString(mappedTokens).trim();
};
export var serializeLogicString = function (uiJSON, prevLogicString, logicStringOperator) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    var prevLogicStringTokens = getLogicStringTokens(prevLogicString);
    var prevLogicStringOperator = getLogicStringOperator(prevLogicStringTokens);
    var currentLogicStringOperator = logicStringOperator || prevLogicStringOperator;
    var updatedLogicString = '';
    var uiBlocks = uiJSON.uiBlocks;
    var _loop_1 = function (uiBlockIdx) {
        var uiBlock = uiBlocks[uiBlockIdx];
        var uiBlockNodeId = uiBlock.nodeId;
        // Non-location group nodes
        if (NODE_ID_ALPHA_NUMERIC_PATTERN.test(uiBlockNodeId)) {
            var groupLogicOperator = prevLogicStringOperator;
            var logicStringTokenIdx = prevLogicStringTokens.findIndex(function (token) { return token === uiBlockNodeId; });
            var nextLogicStringToken = (_a = prevLogicStringTokens[logicStringTokenIdx + 1]) === null || _a === void 0 ? void 0 : _a.toLowerCase();
            if (logicStringTokenIdx !== -1) {
                if (LOGICAL_OPERATORS.includes(nextLogicStringToken)) {
                    groupLogicOperator = nextLogicStringToken;
                }
            }
            var currentUiBlockGroupId = (_b = uiBlockNodeId.match(NODE_ID_NUMERIC_PATTERN)) === null || _b === void 0 ? void 0 : _b[0];
            var nextUiBlockGroupIdx = uiBlockIdx + 1;
            var nextUiBlockNodeId = (_c = uiBlocks[nextUiBlockGroupIdx]) === null || _c === void 0 ? void 0 : _c.nodeId;
            var nextUiBlockGroupId = (_d = nextUiBlockNodeId === null || nextUiBlockNodeId === void 0 ? void 0 : nextUiBlockNodeId.match(NODE_ID_NUMERIC_PATTERN)) === null || _d === void 0 ? void 0 : _d[0];
            if (currentUiBlockGroupId === nextUiBlockGroupId) {
                updatedLogicString += "(".concat(uiBlockNodeId);
                while (currentUiBlockGroupId === nextUiBlockGroupId) {
                    updatedLogicString += " ".concat(groupLogicOperator, " ").concat(nextUiBlockNodeId);
                    uiBlockIdx = nextUiBlockGroupIdx++;
                    nextUiBlockNodeId = (_e = uiBlocks[nextUiBlockGroupIdx]) === null || _e === void 0 ? void 0 : _e.nodeId;
                    nextUiBlockGroupId = (_f = nextUiBlockNodeId === null || nextUiBlockNodeId === void 0 ? void 0 : nextUiBlockNodeId.match(NODE_ID_NUMERIC_PATTERN)) === null || _f === void 0 ? void 0 : _f[0];
                }
                updatedLogicString += ')';
            }
            else {
                updatedLogicString += "".concat(((_g = uiBlock.historicalValue) === null || _g === void 0 ? void 0 : _g.negate) ? '~' : '').concat(uiBlockNodeId);
            }
        }
        else {
            // Location group nodes
            if ((_h = uiBlock.rules) === null || _h === void 0 ? void 0 : _h.length) {
                var locationRuleGroupOperator = void 0;
                // Derive location rule group operator
                switch (uiBlock.ctxAttributeUid) {
                    case LOCATION_ATTRIBUTE_UIDS.APPROXIMATE_LIST:
                    case LOCATION_ATTRIBUTE_UIDS.PRECISE_LIST:
                        locationRuleGroupOperator = 'or';
                        break;
                    case LOCATION_ATTRIBUTE_UIDS.APPROXIMATE_LABELS:
                    case LOCATION_ATTRIBUTE_UIDS.PRECISE_LABELS:
                        locationRuleGroupOperator = 'and';
                        break;
                    default:
                        // This won't matter until rule builder ui allows users
                        // to add rule groups based on non-location context plugins
                        locationRuleGroupOperator = 'and';
                }
                var uiBlockRules = uiBlock.rules;
                if (uiBlockRules.length === 1) {
                    updatedLogicString += uiBlockRules[0].nodeId;
                }
                else {
                    updatedLogicString += '(';
                    for (var uiBlockRulesIdx = 0; uiBlockRulesIdx < uiBlockRules.length; uiBlockRulesIdx++) {
                        var uiBlockRule = uiBlockRules[uiBlockRulesIdx];
                        updatedLogicString += uiBlockRule.nodeId;
                        if (uiBlockRulesIdx === uiBlockRules.length - 1) {
                            updatedLogicString += ')';
                        }
                        else {
                            updatedLogicString += " ".concat(locationRuleGroupOperator, " ");
                        }
                    }
                }
            }
            else {
                // Non-group nodes
                updatedLogicString += "".concat(((_j = uiBlock.historicalValue) === null || _j === void 0 ? void 0 : _j.negate) ? '~' : '').concat(uiBlockNodeId);
            }
        }
        // Add root level operator after group
        if (uiBlockIdx < uiBlocks.length - 1) {
            updatedLogicString += " ".concat(currentLogicStringOperator, " ");
        }
        out_uiBlockIdx_1 = uiBlockIdx;
    };
    var out_uiBlockIdx_1;
    for (var uiBlockIdx = 0; uiBlockIdx < uiBlocks.length; uiBlockIdx++) {
        _loop_1(uiBlockIdx);
        uiBlockIdx = out_uiBlockIdx_1;
    }
    return updatedLogicString;
};
export var serializeResponseBody = function (uiJSON, prevCondition, logicStringOperator) {
    var _a, _b, _c;
    var body = {
        templateId: (_a = uiJSON.templateId) !== null && _a !== void 0 ? _a : '',
        refId: (_b = uiJSON.refId) !== null && _b !== void 0 ? _b : '',
        id: (_c = uiJSON.id) !== null && _c !== void 0 ? _c : '',
        payload: __assign({ name: uiJSON.name, headName: uiJSON.headName, logic: uiJSON.condition, scope: uiJSON.scope, predicates: {}, constraints: uiJSON.constraints }, uiJSON.inheritedPayloadProperties),
    };
    uiJSON.uiBlocks.map(function (block) {
        var e_2, _a;
        var _b, _c, _d, _e, _f, _g;
        var isCtxAttributeUidLocationType = LOCATION_ATTRIBUTE_UID_LIST.includes((_b = block.ctxAttributeUid) !== null && _b !== void 0 ? _b : '');
        var iscontextComparisonPlugin = !!block.contextComparisonPlugin;
        // Location Block
        if (isCtxAttributeUidLocationType) {
            if ((_c = block.rules) === null || _c === void 0 ? void 0 : _c.length) {
                try {
                    for (var _h = __values(block.rules), _j = _h.next(); !_j.done; _j = _h.next()) {
                        var rule = _j.value;
                        var _block = __assign(__assign({}, block), { nodeId: rule.nodeId, ctxVariable: rule.ctxVariable, parameterValues: rule.parameterValues, value: rule.value, attributeName: rule.attributeName });
                        body.payload.predicates[rule.nodeId] = {
                            name: block.operator,
                            parameters: serializeParameterBlocks(_block),
                        };
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (_j && !_j.done && (_a = _h.return)) _a.call(_h);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
            }
            else {
                delete body.payload.predicates[block.nodeId];
            }
        }
        else if (block.useRaw) {
            if (iscontextComparisonPlugin) {
                body.payload.predicates[block.nodeId] = {
                    name: block.operator,
                    parameters: serializeParameterBlocks(block),
                };
            }
            else {
                if (block.value) {
                    body.payload.predicates[block.nodeId] = {
                        name: block.type === 'historical' ? (_d = block === null || block === void 0 ? void 0 : block.historicalValue) === null || _d === void 0 ? void 0 : _d.histOperator : block.operator,
                        parameters: serializeParameterBlocks(block),
                    };
                }
                else {
                    body.payload.predicates[block.nodeId] = block.rawPredicate;
                }
            }
        }
        else {
            body.payload.predicates[block.nodeId] = {
                name: block.type === 'historical' ? (_e = block === null || block === void 0 ? void 0 : block.historicalValue) === null || _e === void 0 ? void 0 : _e.histOperator : block.operator,
                parameters: serializeParameterBlocks(block),
            };
            if (((_f = block === null || block === void 0 ? void 0 : block.hasPlaceHolder) === null || _f === void 0 ? void 0 : _f.name) && body.payload.predicates[block.nodeId].name === '{{P}}') {
                body.payload.predicates[block.nodeId].hasPlaceHolder = ((_g = block === null || block === void 0 ? void 0 : block.hasPlaceHolder) === null || _g === void 0 ? void 0 : _g.name) || false;
            }
        }
    });
    var parsedMetadata = JSON.parse(uiJSON.metadata || '{}');
    if (!parsedMetadata.isCustomLogic) {
        var conditionLogic = serializeLogicString(uiJSON, prevCondition, logicStringOperator);
        if (conditionLogic !== prevCondition) {
            if (body.payload) {
                uiJSON.condition = conditionLogic;
                body.payload.logic = conditionLogic;
            }
            else {
                uiJSON.condition = '';
            }
        }
    }
    body.payload.metadata = uiJSON.metadata || '{}';
    body.payload.logic = body.payload.logic ? body.payload.logic.trim() : '';
    return body;
};
export var getConstraints = function (args) {
    var _a, _b, _c;
    var logicConstraints = [];
    for (var property in args === null || args === void 0 ? void 0 : args.constraints) {
        if (property.includes('logic')) {
            logicConstraints.push({
                nodeId: (_a = property === null || property === void 0 ? void 0 : property.split('.')) === null || _a === void 0 ? void 0 : _a[1],
                invisible: (_b = args === null || args === void 0 ? void 0 : args.constraints[property]) === null || _b === void 0 ? void 0 : _b.invisible,
                uneditable: (_c = args === null || args === void 0 ? void 0 : args.constraints[property]) === null || _c === void 0 ? void 0 : _c.uneditable,
            });
        }
    }
    var predicateConstraints = [];
    // build predicate constraint map similarly
    return {
        logicConstraints: logicConstraints,
        predicateConstraints: predicateConstraints,
        rawConstraint: args === null || args === void 0 ? void 0 : args.constraints,
    };
};
//# sourceMappingURL=transformations.js.map